<h3 fxLayout="row">
  <app-fly-to [lngLat]="[building.longitude, building.latitude]">
    <strong *ngIf="editionMode">{{building.id}}</strong>
  </app-fly-to>
  <span fxFlex></span>
  <app-fly-to *ngIf="vertex" [lngLat]="[vertex.longitude, vertex.latitude]">
    <span i18n>Vertex <strong>{{vertex.id}}</strong></span>
  </app-fly-to>
</h3>

<app-loading *ngIf="isLoading"></app-loading>


<form *ngIf="formBuilding" [formGroup]="formBuilding">

  <section>
    <mat-form-field appearance="outline" class="app-block">
      <mat-label i18n>Street Name</mat-label>
      <input matInput formControlName="street_name">
    </mat-form-field>

    <mat-form-field appearance="outline" class="app-block">
      <mat-label i18n>Number</mat-label>
      <input matInput formControlName="number">
    </mat-form-field>

    <mat-form-field appearance="outline" class="app-block">
      <mat-label i18n>Complement</mat-label>
      <input matInput formControlName="complement">
    </mat-form-field>
  </section>

  <section>
    <h4 i18n>Features</h4>

    <h5 i18n>Collectivity</h5>

    <mat-button-toggle-group formControlName="occupancy">
      <mat-button-toggle value="Individual" i18n>Individual</mat-button-toggle>
      <mat-button-toggle value="Collective" i18n>Collective</mat-button-toggle>
    </mat-button-toggle-group>

    <ng-container *ngIf="formBuilding.value.occupancy === 'Collective'">

      <mat-form-field appearance="outline" class="app-block">
        <mat-label i18n>Building name</mat-label>
        <input matInput formControlName="name">
      </mat-form-field>

    </ng-container>

    <h5 i18n>Main use</h5>

    <mat-button-toggle-group formControlName="type">
      <mat-button-toggle value="Residential" i18n>Residential</mat-button-toggle>
      <mat-button-toggle value="NonResidential" i18n>Non Residential</mat-button-toggle>
      <mat-button-toggle value="Mixed" *ngIf="formBuilding.value.occupancy === 'Collective'" i18n>
        Mixed
      </mat-button-toggle>
    </mat-button-toggle-group>

    <ng-container *ngIf="formBuilding.value.occupancy === 'Collective'">

      <h5 i18n>Orientation</h5>

      <mat-button-toggle-group formControlName="orientation">
        <mat-button-toggle value="Horizontal" i18n>Horizontal</mat-button-toggle>
        <mat-button-toggle value="Vertical" i18n>Vertical</mat-button-toggle>
      </mat-button-toggle-group>


      <ng-container *ngIf="formBuilding.value.orientation === 'Horizontal'">
        <h5 i18n>Units</h5>

        <mat-form-field *ngIf="formBuilding.value.type !== 'NonResidential'" appearance="outline"
          class="app-block num-field">
          <mat-label i18n>Residential Units</mat-label>
          <button mat-icon-button matPrefix (click)="minus(formBuilding, 'residential_units')"
            [disabled]="formBuilding.value.residential_units <= 0">
            <mat-icon>remove</mat-icon>
          </button>
          <input type="number" matInput formControlName="residential_units">
          <button mat-icon-button matSuffix (click)="plus(formBuilding, 'residential_units')">
            <mat-icon>add</mat-icon>
          </button>
        </mat-form-field>
        <mat-error *ngIf="formBuilding.errors?.residentialUnitsMin" i18n>
          Must be greater than zero
        </mat-error>

        <mat-form-field *ngIf="formBuilding.value.type !== 'Residential'" appearance="outline"
          class="app-block num-field">
          <mat-label i18n>Non Residencial Units</mat-label>
          <button mat-icon-button matPrefix (click)="minus(formBuilding, 'nonresidential_units')"
            [disabled]="formBuilding.value.nonresidential_units <= 0">
            <mat-icon>remove</mat-icon>
          </button>
          <input matInput type="number" formControlName="nonresidential_units">
          <button mat-icon-button matSuffix (click)="plus(formBuilding, 'nonresidential_units')">
            <mat-icon>add</mat-icon>
          </button>
        </mat-form-field>
        <mat-error *ngIf="formBuilding.errors?.nonResidentialUnitsMin" i18n>
          Must be greater than zero
        </mat-error>
      </ng-container>

      <ng-container *ngIf="formBuilding.value.orientation === 'Vertical'">
        <h5 i18n>Blocks</h5>
        <div fxLayout="row wrap">
          <div fxFlex="50" *ngFor="let blockForm of this.blocksForm.controls; let i = index;">
            <div class="block-card" [formGroup]="blockForm">
              <mat-card>

                <mat-form-field appearance="outline" class="app-block">
                  <mat-label i18n>Name</mat-label>
                  <input matInput formControlName="name">
                </mat-form-field>

                <mat-form-field appearance="outline" class="app-block num-field">
                  <mat-label i18n>Floors</mat-label>
                  <button type="button" mat-icon-button matPrefix (click)="minus(blockForm, 'floors')"
                    [disabled]="blockForm.value.floors <= 1">
                    <mat-icon>remove</mat-icon>
                  </button>
                  <input matInput type="number" formControlName="floors">
                  <button type="button" mat-icon-button matSuffix (click)="plus(blockForm, 'floors')">
                    <mat-icon>add</mat-icon>
                  </button>
                </mat-form-field>

                <mat-form-field *ngIf="formBuilding.value.type !== 'NonResidential'" appearance="outline"
                  class="app-block num-field">
                  <mat-label i18n>Residential Units</mat-label>
                  <button mat-icon-button matPrefix (click)="minus(blockForm, 'residential_units')"
                    [disabled]="blockForm.value.residential_units <= 0">
                    <mat-icon>remove</mat-icon>
                  </button>
                  <input matInput type="number" formControlName="residential_units">
                  <button mat-icon-button matSuffix (click)="plus(blockForm, 'residential_units')">
                    <mat-icon>add</mat-icon>
                  </button>
                </mat-form-field>
                <mat-error *ngIf="formBuilding.getError('block_' + i + '_residentialUnitsMin')" i18n>
                  Must be greater than zero
                </mat-error>

                <mat-form-field *ngIf="formBuilding.value.type !== 'Residential'" appearance="outline"
                  class="app-block num-field">
                  <mat-label i18n>Non Residencial Units</mat-label>
                  <button mat-icon-button matPrefix (click)="minus(blockForm, 'nonresidential_units')"
                    [disabled]="blockForm.value.nonresidential_units <= 0">
                    <mat-icon>remove</mat-icon>
                  </button>
                  <input matInput type="number" formControlName="nonresidential_units">
                  <button mat-icon-button matSuffix (click)="plus(blockForm, 'nonresidential_units')">
                    <mat-icon>add</mat-icon>
                  </button>
                </mat-form-field>
                <mat-error *ngIf="formBuilding.getError('block_' + i + '_nonResidentialUnitsMin')" i18n>
                  Must be greater than zero
                </mat-error>

                <button type="button" mat-icon-button (click)="deleteBlock(i)" [disabled]="i === 0" i18n-title
                  title="Delete block">
                  <mat-icon>delete</mat-icon>
                </button>

              </mat-card>
            </div>
          </div>
          <div fxFlex>
            <button type="button" mat-raised-button color="primary" class="add-btn" (click)="addBlock()">
              <mat-icon>add</mat-icon>
              <span i18n>BLOCK</span>
            </button>
          </div>
        </div>

      </ng-container>
    </ng-container>
  </section>

  <mat-action-row>
    <button mat-stroked-button color="warn" *ngIf="editionMode" (click)="remove()">
      <span *ngIf="removeConfirmated else removeBlock" i18n>CONFIRM?</span>
    </button>
    <button mat-raised-button (click)="save()" [disabled]="!formBuilding.valid" i18n>SAVE</button>
  </mat-action-row>

</form>

<ng-template #removeBlock i18n>REMOVE</ng-template>
